// extracted by mini-css-extract-plugin
export var body = "_ke-0";
export var sectionHeader = "_ke-4";
export var shortcutColumns = "_ke-2";
export var shortcutList = "_ke-1";
export var shortcutSection = "_ke-3";